function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9,3 C9,4.657 7.657,6 6,6 C4.343,6 3,4.657 3,3 C3,1.343 4.343,0 6,0 C7.657,0 9,1.343 9,3 Z M12,20 C8.986,20 6.675,18.864 6.212,18.305 C6.069,18.132 6,17.912 6,17.687 L6,14 C6,12.896 6.896,12 8,12 L16,12 C17.104,12 18,12.896 18,14 L18,17.687 C18,17.912 17.93,18.133 17.787,18.306 C17.322,18.866 15.012,20 12,20 Z M12,5 C13.657,5 15,6.343 15,8 C15,9.657 13.657,11 12,11 C10.343,11 9,9.657 9,8 C9,6.343 10.343,5 12,5 Z M7,8 C7,8.734 7.168,9.427 7.454,10.056 C5.508,10.324 4,11.981 4,14 L4,14.829 C2.001,14.492 0.565,13.732 0.212,13.305 C0.069,13.132 0,12.912 0,12.687 L0,9 C0,7.896 0.896,7 2,7 L7.102,7 C7.035,7.323 7,7.657 7,8 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-1 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/line.a972e4f0.svg";
export { SvgComponent as ReactComponent };